import React, { Component } from 'react';
import LayoutHeader from '../Inc/Header';
import AlumniNavigation from '../Inc/AlumniNavigation';
import FAQ from '../Inc/FAQ';

class FAQPage extends Component {

  constructor(props) {
    super(props)
    this.state = {
      ...props,
    }
  }

  render() {
    return (
      <div>
        <LayoutHeader />
        <AlumniNavigation />
        <FAQ />
      </div>
    );
  }

}


export default FAQPage;





// WEBPACK FOOTER //
// ./src/components/FAQ/index.js